import "./TypeFilter.css";

const TypeFilter = ({ filter, onChange }) => {

  const handleChange = (value) => {
    onChange({ target: { value } });
  };

  return (
    <div className="type-toggle">

      <button
        className={filter === "all" ? "active" : ""}
        onClick={() => handleChange("all")}
      >
        ALL
      </button>

      <button
        className={filter === "BUY" ? "active" : ""}
        onClick={() => handleChange("BUY")}
      >
        BUY
      </button>

      <button
        className={filter === "SELL" ? "active" : ""}
        onClick={() => handleChange("SELL")}
      >
        SELL
      </button>

    </div>
  );
};

export default TypeFilter;